module.exports = __webpack_public_path__ + "auMade.png?aae20a136bcd64370fc354681b325697";